import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { TextInput} from "@egovernments/digit-ui-react-components";
import { Box, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';

const KhasraArea = ({ khasraArea, handleKhasraChange, handleAreaChange, addRow, deleteRow, t }) => {
  let validation = {}
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t("BPA_PLOT_KHASARA_NO_LABEL")}</TableCell>
          <TableCell>{t("BPA_DOL_AREA_SQM_LABEL")}</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {khasraArea.map((elementInArray, index) => (
          <TableRow key={index}>
            <TableCell>
              <TextInput
                t={t}
                type="text"
                isMandatory={false}
                optionKey="i18nKey"
                name="khataNo"
                value={elementInArray.khasra}
                onChange={(e) => handleKhasraChange(e, index)}
                {...(validation = {
                  isRequired: true,
                  pattern: "^[a-zA-Z-.`' ]*$",
                  type: "text",
                  title: t("PT_NAME_ERROR_MESSAGE"),
                })}
              />
            </TableCell>
            <TableCell>
              <TextInput
                t={t}
                type="text"
                isMandatory={false}
                optionKey="i18nKey"
                name="area"
                value={elementInArray.area}
                onChange={(e) => handleAreaChange(e, index)}
              />
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', gap: '.5rem', mt: "-1.2rem", ml: '.5rem' }}>
                <IconButton color="primary" aria-label="add" onClick={addRow}>
                  <AddBoxIcon />
                </IconButton>
                {index > 0 && (
                  <IconButton color="error" aria-label="delete" onClick={() => deleteRow(index)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default KhasraArea;
